// extracted by mini-css-extract-plugin
export default {"Projects":"Projects_Projects__TXrDP","titleSize":"Projects_titleSize__6cnXd","Cards":"Projects_Cards__etwe6"};